import { Action } from "redux";

import { APIFailureAction, APIRequestAction, APISuccessAction } from "@/mk2/helpers/action";
import { NormalizedResponse } from "@/mk2/helpers/api";

// API
export interface ReactionSaveAction extends Action {
    readonly entity: string;
    readonly id: number;
}

export const REACTION_SAVE_REQUEST = "REACTION_SAVE_REQUEST";
export interface ReactionSaveRequestAction extends ReactionSaveAction, APIRequestAction {
    readonly type: typeof REACTION_SAVE_REQUEST;
    readonly response: NormalizedResponse;
}

export const REACTION_SAVE_SUCCESS = "REACTION_SAVE_SUCCESS";
export interface ReactionSaveSuccessAction extends ReactionSaveAction, APISuccessAction {
    readonly type: typeof REACTION_SAVE_SUCCESS;
}

export const REACTION_SAVE_FAILURE = "REACTION_SAVE_FAILURE";
export interface ReactionSaveFailureAction extends ReactionSaveAction, APIFailureAction {
    readonly type: typeof REACTION_SAVE_FAILURE;
    // response contains the reverted (previous) state so entities reducer rolls back optimistic update
    readonly response: NormalizedResponse;
}

export const reactionSave = {
    // Sends fake optimistic response in request so entities reducer updates immediately
    request: (
        entity: string,
        id: number,
        response: NormalizedResponse,
    ): ReactionSaveRequestAction => ({ type: REACTION_SAVE_REQUEST, entity, id, response }),
    success: (
        entity: string,
        id: number,
        response: NormalizedResponse,
    ): ReactionSaveSuccessAction => ({ type: REACTION_SAVE_SUCCESS, entity, id, response }),
    // response contains prev state to revert the optimistic update
    failure: (
        entity: string,
        id: number,
        error: any,
        response: NormalizedResponse,
    ): ReactionSaveFailureAction => ({ type: REACTION_SAVE_FAILURE, entity, id, error, response }),
};

// Triggers
export const REACTION_CHANGE = "REACTION_CHANGE";

export interface ReactionChangeAction extends Action {
    readonly type: typeof REACTION_CHANGE;
    readonly id: number;
    readonly entity: string;
    readonly emojiType: string | null;
}

export const reactionChange = (
    entity: string,
    id: number,
    emojiType: string | null,
): ReactionChangeAction => ({ type: REACTION_CHANGE, entity, id, emojiType });
